var _defs, _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #262626;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #389638;\r\n      }\r\n\r\n      .st3 {\r\n        fill: #bde0c1;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    className: "st3",
    d: "M13.2,0h17.4c1.4,0,2.5,1.1,2.5,2.5v37.1c0,1.4-1.1,2.5-2.5,2.5H5.4c-1.4,0-2.5-1.1-2.5-2.5V10.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    className: "st2",
    d: "M13.2,0v7.8c0,1.4-1.1,2.5-2.5,2.5H3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    className: "st1",
    d: "M.3,29.4h2.7v-3.5l-3,3.6h0s.1-.1.2-.1h.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    className: "st1",
    d: "M35.7,29.4h-2.7v-3.5l2.9,3.6h0s0-.1-.2-.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    className: "st2",
    d: "M33.2,37.2c0,.2-.3.4-.6.4H3.4c-.2,0-.5-.2-.6-.4l-2.8-7.5c0-.1,0-.3.1-.4h35.6s.3,0,.3.2h0c0,.1-2.8,7.5-2.8,7.5,0,0,0,.2,0,.2Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    className: "st0",
    d: "M9.7,35.4c0-.2,0-.4.2-.5s.3-.2.5-.2.4,0,.5.2c.1,0,.2.3.2.5s0,.3-.2.5c-.1,0-.3.2-.5.2s-.4,0-.5-.2c-.1,0-.2-.3-.2-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.8,36.6c-.2,0-.3,0-.5-.2,0,0-.2-.3-.2-.4s0-.4.2-.5l1.1-1.3-1-1.2c-.2-.2-.3-.3-.3-.6s0-.3.2-.4c.2-.2.3-.2.5-.2h.5c.2,0,.3.2.3.3l.6.8.6-.8c.3-.3.5-.4.9-.4s.3,0,.5.2c.2,0,.2.3.2.4s0,.4-.3.6l-1,1.2,1.1,1.3c.2.2.3.3.3.5v.4c-.2,0-.3.2-.5.2h-.5c-.2,0-.3-.2-.4-.3l-.7-.9-.7.9c-.2,0-.3.3-.5.3,0,0-.3.2-.4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6,36.6c-.5,0-1-.2-1.3-.5-.3-.4-.5-.9-.4-1.5v-4.1c0-.4.3-.8.7-.8h.2c.4,0,.8.3.8.7v4.2c0,.2,0,.3.2.5s.3.2.3.2h.6v.5c0,.2,0,.3-.2.5s-.3.2-.4.3h-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.3,36.6h-.8c-.3,0-.5,0-.8-.3-.2,0-.3-.2-.4-.3v-.4c0-.2.2-.3.3-.3h.4c.3,0,.5.2.8.2h1.1s.2-.2.2-.3v-.3h-.3l-1.1-.2c-.3,0-.7-.2-.9-.4-.3-.3-.3-.6-.3-.9s0-.6.3-.8c.2-.3.5-.4.8-.6.3-.2.8-.2,1.2-.2h.8c.3,0,.5,0,.7.3.2,0,.3.2.3.3,0,.3,0,.7-.3.8h-.5c-.2,0-.3-.2-.6-.2h-1s-.2.2-.2.3c0,.2,0,.3.3.3l1.1.2c.3,0,.7.2.9.4.3.3.3.6.3.8,0,.5-.2.9-.6,1.2-.5.3-1,.4-1.6.3h.2-.3Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    d: "M13.1,15.9c1.3-2.3,4.1-3.2,6.5-2,.9.4,1.6,1.2,2.1,2-1.3,2.3-4.1,3.2-6.5,2-.9-.4-1.6-1.2-2.1-2ZM17.4,17.6c.9,0,1.7-.8,1.7-1.8,0-.9-.8-1.7-1.8-1.7-.9,0-1.7.8-1.7,1.7,0,1,.8,1.7,1.7,1.7,0,0,0,0,0,0ZM17.4,16.7c-.5,0-.8-.4-.8-.9,0-.5.4-.8.9-.8.5,0,.8.4.8.9,0,.5-.4.9-.9.9h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_68",
    d: "M17.2,9.2c3.8,0,6.9,3.1,6.9,6.9s-3.1,6.9-6.9,6.9-6.9-3.1-6.9-6.9,3.1-6.9,6.9-6.9h0ZM17.2,22c3.3,0,5.9-2.6,5.9-5.9s-2.6-5.9-5.9-5.9-5.9,2.6-5.9,5.9c0,0,0,0,0,0,0,3.3,2.6,5.9,5.9,5.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Line_48",
    d: "M25.2,24.6c-.1,0-.3,0-.4-.1l-3.5-3.5c-.2-.2-.2-.5,0-.7.2-.2.5-.2.7,0l3.5,3.5c.2.2.2.5,0,.7,0,0-.2.1-.4.1h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelPreview);
export default __webpack_public_path__ + "static/media/EXCEL Preview.9c54d0b5b3bc811d33c753e790b35e28.svg";
export { ForwardRef as ReactComponent };